function fnWorkCarousel( i, oSection ) {

	var oSection				= $( oSection );
	var oCarousel				= oSection.find( '.owl-carousel' );

	$( oCarousel ).owlCarousel({
		items: 				1,
		smartSpeed: 		600,
		dots: 				false,
		nav: 				true,
		loop: 				false,
		margin: 			20,
		autoHeight: 		true,
		autoWidth: 			false,
		mouseDrag: 			true,
		stagePadding:		0,
		autoplay: 			false,
		responsive:			{
			0: {
				stagePadding:	0,
			},
			960: {
				stagePadding: 	90,
			},
			1260: {
				stagePadding: 	180,
			}
		}
	});

}
